import { render, staticRenderFns } from "./ConsentGrant.vue?vue&type=template&id=acb3c8fa"
import script from "./ConsentGrant.vue?vue&type=script&lang=ts"
export * from "./ConsentGrant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports